"use client";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import { WhiteSpinner } from "../common/Icons";
import {
	InputOTP,
	InputOTPGroup,
	InputOTPSeparator,
	InputOTPSlot,
} from "../ui/input-otp";

const PhoneOtp = ({
	setOtp,
	otp,
	phoneNumber,
	submitHandler,
	resendOtpHandler,
	resendLoading,
	resendCountdown,
	getResendButtonText,
	error,
	isPending,
}: {
	isPending: boolean;
	error: string | null;
	submitHandler: (e: React.FormEvent<HTMLFormElement>) => void;
	setOtp: (value: string) => void;
	setShowOtp: (value: boolean) => void;
	otp: string;
	resendOtpHandler?: () => void;
	resendLoading?: boolean;
	resendCountdown?: number;
	getResendButtonText?: () => string;
	phoneNumber: string;
}) => {
	return (
		<form
			onSubmit={(e) => submitHandler(e)}
			className="flex flex-col gap-2 items-center justify-center w-full h-full">
			<p className="font-semibold text-lg md:text-xl lg:text-2xl xl:text-[28px] text-[#5E57EB] text-center">
				Almost There!
			</p>
			<p className="font-semibold text-sm sm:text-base lg:text-lg 2xl:text-xl text-center ff_poppins mb-5">
				We&apos;ve texted a 6-digit code to your number ending in
				{phoneNumber.replace(/\d(?=\d{4})/g, "x")}. Enter it below to jump right
				in!
			</p>
			<InputOTP
				required
				pattern={REGEXP_ONLY_DIGITS}
				maxLength={6}
				value={otp}
				onChange={(val) => setOtp(val)}>
				<InputOTPGroup>
					<InputOTPSlot
						index={0}
						className="ff_poppins text-xl sm:text-2xl lg:text-[28px] 2xl:!text-[30px]"
					/>
					<InputOTPSlot
						index={1}
						className="ff_poppins text-xl sm:text-2xl lg:text-[28px] 2xl:!text-[30px]"
					/>
					<InputOTPSlot
						index={2}
						className="ff_poppins text-xl sm:text-2xl lg:text-[28px] 2xl:!text-[30px]"
					/>
				</InputOTPGroup>
				<InputOTPSeparator />
				<InputOTPGroup>
					<InputOTPSlot
						index={3}
						className="ff_poppins text-xl sm:text-2xl lg:text-[28px] 2xl:!text-[30px]"
					/>
					<InputOTPSlot
						index={4}
						className="ff_poppins text-xl sm:text-2xl lg:text-[28px] 2xl:!text-[30px]"
					/>
					<InputOTPSlot
						index={5}
						className="ff_poppins text-xl sm:text-2xl lg:text-[28px] 2xl:!text-[30px]"
					/>
				</InputOTPGroup>
			</InputOTP>
			<span className="text-[#CD2C2C] ff_poppins capitalize text-xs sm:text-sm md:text-base lg:text-base font-medium leading-[16.41px] mt-3 inline-block ">
				{error}
			</span>

			<div className="flex justify-center mt-4">
				<button
					type="button"
					onClick={resendOtpHandler}
					disabled={(resendCountdown && resendCountdown > 0) || resendLoading}
					className={`ff_poppins text-sm font-medium underline transition-colors ${
						resendCountdown === 0 && !resendLoading
							? "text-[#5E57EB] cursor-pointer"
							: "text-gray-400 no-underline cursor-not-allowed"
					}`}>
					{getResendButtonText && getResendButtonText()}
				</button>
			</div>

			<button
				type="submit"
				disabled={isPending || otp.length < 6}
				className={`font-semibold ff_poppins w-full mt-5 text-white text-lg md:text-xl xl:text-2xl py-[14px] sm:py-4 lg:py-[19.5px] rounded-xl gradient_button_shadow bg-button-gradient text-center hover:scale-105 duration-300 ease-in-out ${isPending || otp.length < 6 ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}>
				{isPending ? <WhiteSpinner /> : "Verify Now"}
			</button>
		</form>
	);
};

export default PhoneOtp;
